export var Align;
(function (Align) {
  Align["left"] = "left";
  Align["center"] = "center";
  Align["right"] = "right";
})(Align || (Align = {}));